const getRandomInt = (min, max) => {
  const minInt = Math.ceil(min);
  const maxInt = Math.floor(max);
  return Math.floor(Math.random() * (minInt - maxInt)) + minInt;
};

export { getRandomInt };
